const DataRestoreKeys = {
    TITLE: "title",
    MODULE: "module",
    TYPE: "type",
    RESTORE_BY: "restoreBy",
    DATE_FROM: "dateFrom",
    DATE_TO: "dateTo",
    BOND_NUMBER: "bondNumber",
    TRIP_NUMBER: "tripNumber",
    SHIPMENT_CONTROL_NUMBER: "shipmentControlNumber",
    DAY_TO_RETAIN: "dayToRetain",
    USER_ID: "userId",
    BUTTON: "button",
    HELP_TEXT_1: "helpText1",
    ERROR_MESSAGE: "errorMessage",
    SUBMIT_BUTTON: "submitButton",
    ERROR_MESSAGE_TPR_USER: "errorMessageTPRUser",
    ERROR_MESSAGE_TPR_USER_PREFERENCE: "errorMessageTPRUserPreference",
    SUCCESS_MESSAGE: "successMessage",
    PRIMARY_CCN: "primaryCCN",
    PREVIOUS_CCN: "previousCCN",
    CCN: "ccn",
    CBSA_REF_NO: "cbsaRefNo",
    SCAC: "scac",
    VESSEL_NAME: "vesselName",
    VOYAGE_NUMBER: "voyageNumber",
    PORT_OF_DISCHARGE: "portOfDischarge",
    ETA: "eta",
    CCN_TRANS_NO: "ccnTransNo",
    FDAPN_REF_ID: "fdapnRefId",
    SHIPMENT_REFERENCE_NUMBER: "shipmentReferenceNumber",
    CONV_REFNO: "convRefNo",
    ACTUAL_ARRIVAL_DATE: "actualArrivalDate",
    BL_NUMBER: "blNumber",
    IMPORTER_DOCUMENT_NUMBER: "importerDocumentNumber",
    ERROR_MESSAGE_FILE_FOR_USER_PROFILE: "errorMessageFileForUserProfile",
    ERROR_MESSAGE_FILE_FOR_USER_CORP_ID: "errorMessageFileForUserCorpId",
    ERROR_MESSAGE_LOGGED_IN_USER_CORP_ID: "errorMessageLoggedInUserCorpId",
    ERROR_MESSAGE_LOGGED_IN_USER_PROFILE: "errorMessageLoggedInUserProfile",
    ERROR_MESSAGE_RETRIEVE_DATA: "errorMessageRetrieveData",
    ERROR_MESSAGE_CORP_ID_NOT_MATCH: "errorMessageCorpIdNotMatch",
    ERROR_MESSAGE_CHILD_CORP_ID_NOT_MATCH : "errorMessageChildCorpIdNotMatch",
    ERROR_MESSAGE_SERVICE_BUREAU_FLAG: "errorMessageServiceBureauFlag",
    ERROR_MESSAGE_SERVICE_BUREAU_CHILD_CORP_ID_FLAG: "errorMessageServiceBureauChildCorpIdFlag",
    ERROR_MESSAGE_TPR_USER_DETAILS: "errorMessageTPRUserDetails",
    ERROR_MESSAGE_TPR_USER_DETAILS_INACTIVE: "errorMessageTPRUserDetailsInactive",
    DAY_TO_RETAIN_HELPER_TEXT: "dayToRetainHelperText",
    Validations: {
        ERROR_MSG_MAX_LENGTH : "validations.errMsgMaxLength",
        ERROR_MSG_NUMERIC: "validations.errMsgNumeric",
        ERROR_MSG_MAX_VALUE : "validations.errMsgMaxValue",
        ERROR_DATA_RESTORE_DATE_RANGE: "validations.errDataRestoreDateRange",
        ERROR_DATE_FROM_LESSER_THAN_DATE_TO: "validations.errDateFromLesserThanDateTo",
        ERROR_DATE_TO_GREATER_THAN_DATE_FROM: "validations.errDateToGreaterThanDateFrom",
    }
}

export default DataRestoreKeys